export default function AboutHero() {
  return (
    <section className="relative h-[420px] md:h-[520px] flex items-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=premium%20luxury%20residential%20villa%20community%20aerial%20view%20lush%20green%20landscape%20Bengaluru%20India%20modern%20architecture%20beautiful%20garden%20pathway%20serene%20environment%20professional%20photography%20wide%20angle&width=1600&height=600&seq=abouthero001&orientation=landscape"
        alt="Urban Infra premium residential development Bengaluru"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-[#1B2A4A]/80 via-[#1B2A4A]/60 to-[#1B2A4A]/30"></div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-8">
        <nav className="flex items-center gap-2 text-white/70 text-xs mb-6" aria-label="Breadcrumb">
          <a href="/" className="hover:text-white transition-colors cursor-pointer">Home</a>
          <i className="ri-arrow-right-s-line text-[#7FBF3F]"></i>
          <span className="text-white font-medium">About Us</span>
        </nav>

        <span className="inline-block text-xs font-bold uppercase tracking-widest text-[#7FBF3F] bg-white/10 backdrop-blur-sm border border-white/20 px-3 py-1.5 rounded-full mb-5">
          Our Story
        </span>
        <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-5 max-w-2xl" style={{ fontFamily: "'Playfair Display', serif" }}>
          About Urban Infra
        </h1>
        <p className="text-white/85 text-base md:text-lg leading-relaxed max-w-xl mb-8">
          Building trusted residential spaces across Bengaluru with planning, quality, and long-term value.
        </p>
        <div className="flex flex-col sm:flex-row gap-3">
          <a href="/about#enquire" className="inline-flex items-center justify-center gap-2 bg-[#7FBF3F] hover:bg-[#6aaa32] text-white font-semibold text-sm px-6 py-3 rounded-lg transition-all duration-300 cursor-pointer whitespace-nowrap">
            <i className="ri-calendar-check-line"></i>Book Now
          </a>
          <a href="/urbaninfra" className="inline-flex items-center justify-center gap-2 border-2 border-white/50 text-white font-semibold text-sm px-6 py-3 rounded-lg hover:bg-white/10 transition-all duration-300 cursor-pointer whitespace-nowrap">
            <i className="ri-building-4-line"></i>View Projects
          </a>
        </div>
      </div>
    </section>
  );
}
